<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<!--<div class="imgBox">
	   	 <img src="../../assets/images/Membership.jpg">
	   </div>-->
		<!-- 团体会员 -->
		<div v-if="isGroupMember">
			<div class="car-box group-box" id="card" v-cloak>
				<div id="qrcode" class="qrCode">
					<qrcode :value="codeUrl" :options="{ size: 62 }"></qrcode>
				</div>
				<ul>
					<li style="margin-left:-40px" :class="{'smallBottom':userInfo.company&&userInfo.company.length > 15}">
						{{userInfo.name || '--'}}</li>
					<li>{{getMemberType(userInfo.memberType) || ''}}</li>
					<li>{{userInfo.expiryDate | formatDate}}</li>
					<li>{{userInfo.memberNo || '未生成会员号'}}</li>
					<li>{{getRecommendUnit(userInfo.recommendUnitId)}}</li>
				</ul>
			</div>
		</div>
		<!-- 个人会员 -->
		<div v-else>
			<div class="car-box isSSOC" id="card" v-cloak>
				<div id="qrcode" class="qrCode">
					<qrcode :value="codeUrl" :options="{ size: 62 }"></qrcode>
				</div>
				<template v-if="userInfo.portraitId">
					<div class="portrait" id="demo" :style="{backgroundImage:'url(' + PZUrl + ')'}"></div>
				</template>
				<ul>
					<li :class="{'smallBottom':userInfo.company&&userInfo.company.length > 15}">{{userInfo.name || '--'}}</li>
					<li>{{userInfo.gender==1?"男":"女"}}{{signalStrength}}</li>
					<li>{{getMemberType(userInfo.memberType) || ''}}</li>
					<li>{{userInfo.expiryDate | formatDate}}</li>
					<li>{{userInfo.memberNo || '未生成会员号'}}</li>
					<li>{{getRecommendUnit(userInfo.recommendUnitId)}}</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		getUser,
		baseURL,
		getPortrait,
		getPZUrl,
		getAssociationCurrent,
		getDictionaryByCode,
		getDuesList,
		getBranchs,
		getPaymentList
	} from "@/api/dictionary";
	import Qrcode from "@xkeshi/vue-qrcode";
	import vHead from "../../components/Subhead.vue";
	import { Uploader, Toast, Button, Dialog } from "vant";
	import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
	import { getSessionStore } from "@/utils/sessionStorage.js"

	export default {
		data() {
			return {
				codeUrl: 'http://www.csf.org.cn/mobile/#/memberInfo?code=',
				title: "电子会员证",
				fileList: [],
				photoList: [],
				branchList: [],
				page: 1,
				orderAudit: {
					auditTime: '',
				},
				userInfo: {
					id: "",
					name: "未登录",
					memberTypes: ''
				},
				cardName: "card.png",
				componentName: "",
				cardUrl: "",
				PZUrl: "", //头像地址
				singerList: [],
				signalStrength: ''
			};
		},
		filters: {
			formatDate: function (value) {
				if (!value) {
					return
				}
				let date = new Date(value);
				if (isNaN(date.getTime())) { // 检查日期是否有效  
					return;
				}
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return y + ' 年 ' + MM + ' 月 ' + d + ' 日 ';
			}
		},
		components: {
			vHead,
			[Uploader.name]: Uploader,
			[Toast.name]: Toast,
			[Button.name]: Button,
			[Dialog.name]: Dialog,
			Qrcode
		},
		computed: {
			...mapGetters(["commond", "isGroupMember", "getMemberType"])
		},
		methods: {
			...mapActions([
				"getMemberTypeList",
			]),
			getAssociationCurrent() {
				getAssociationCurrent().then(res => {
					if (res.success) {
						this.componentName = res.result.name;
					}
				});
			},
			getDisplay(id) {
				getPZUrl({ id }).then(res => {
					if (res.success) {
						this.PZUrl = res.result;
					}
				});
			},
			getSingerList(params) {
				getDictionaryByCode(params)
					.then(res => {
						this.singerList = res.result;
					})
			},
			getRecommendUnit(val) {
				let obj = this.branchList.find(item => item.code == val);

				if (obj) {
					return obj.name
				} else {
					return '~'
				}
			},
			getBranchs() {
				getBranchs()
					.then(res => {
						if (res.success) {
							this.branchList = res.result
						}

					})
			},
			compare(value) {
				var obj = this.singerList.filter(function (item) {
					return item.value == value;
				});
				if (!obj.length) return '';
				return obj[0].name;
			},
			getOder() {
				const token = getSessionStore("access_token");
				this.loading = true;
				let orderTypeList = [1, 3, 4, 5]
				getPaymentList({ orderTypeList: orderTypeList, "access_token": token }, this.page - 1)
					.then(res => {
						if (res.result.content && res.result.content[0] && res.result.content[0].orderAudit && res.result.content[0].orderAudit.auditTime) {
							this.orderAudit = res.result.content[0].orderAudit;
							//取出时间  转化
						}
					})
					.catch(() => {
						this.$message.error("获取数据失败");
					})
					.finally(() => {
						this.loading = false;
					});


			},
			getUser() {
				const startTime = new Date().getTime();
				return new Promise((resolve, reject) => {
					getUser()
						.then(data => {
							// 记录结束时间  
							const endTime = new Date().getTime();

							// 计算响应时间  
							const responseTime = endTime - startTime;
							console.log(`获取用户信息的响应时间为: ${responseTime} 毫秒`);
							if (responseTime > 2000) {
								alert('当前网络状况不佳');
								// Dialog.confirm({
								// 	message: '网络不给力，请稍后再试',
								// 	confirmButtonText: "重试",
								// 	cancelButtonText: "取消",
								// })
								// 	.then(() => {
								// 		window.location.reload();
								// 	})
								// 	.catch(() => {
								// 		// on cancel
								// 	});

							}
							// this.userInfo = data.result;
							this.$set(this, 'userInfo', data.result)
							this.codeUrl = this.codeUrl + this.userInfo.id;
							if (this.userInfo.memberCategory == 1) {
								this.getSingerList('MEMBER_TYPE');
							} else {
								this.getSingerList('GROUP_TYPE');
							}
							resolve(data.result);

						})
						.catch(() => {
							this.$message.error("获取用户信息失败！");
						});
				});
			},
			getSignalStrength() {

				// if (navigator.connection) {
				// 	this.signalStrength = navigator.connection.rtt; // 实际代码中可能需要根据实际情况获取信号强度属性
				// 	console.log('{{signalStrength}}', this.signalStrength)
				// 	if (this.signalStrength > 100) {
				// 		Dialog.confirm({
				// 			message: '网络不给力，请稍后再试',
				// 			confirmButtonText: "重试",
				// 			cancelButtonText: "取消",
				// 		})
				// 			.then(() => {
				// 				window.location.reload();
				// 			})
				// 			.catch(() => {
				// 				// on cancel
				// 			});

				// 	}
				// } else {
				// 	// 浏览器不支持navigator.connection，可以添加回退逻辑或警告
				// }

			}
		},
		async created() {
			let data = await this.getUser();
			this.getAssociationCurrent();
			this.cardName = data.name + data.memberNo + ".png";
			this.getDisplay(data.portraitId);
			this.getOder();
			this.getMemberTypeList()
			this.getBranchs();
			this.getSignalStrength();
		},
		mounted: async function () {

		}
	};
</script>

<style lang="less" scoped>
	.imgBox {
		padding: 20px;

		img {
			width: 100%;
		}
	}

	.nav-title {
		display: flex;
		color: #1989fa;
		font-weight: bold;
		align-items: center;

		img {
			width: 17px;
			margin-right: 12px;
		}
	}

	.car-box.isSSOC {
		position: relative;
		margin: 10px auto 0;
		height: 540px;
		background: url("../../assets/images/huax_img.jpg") center no-repeat;
		background-size: 105%;
	}

	.car-box.isSSOC .memberBo {
		width: 110px;
		height: 12px;
		position: absolute;
		top: 195px;
		left: 22px;
		font-size: 12px;
	}

	.car-box.isSSOC ul {
		width: 190px;
		position: absolute;
		top: 6.5rem;
		right: 0.5rem;
		text-align: center;
		line-height: 0;
	}

	.group-box {
		position: relative;
		height: 540px;
		margin: 20px auto 0;
		background: url("../../assets/images/groupCard.jpg") center no-repeat;
		background-size: 100%;
	}

	.car-box.group-box ul {
		width: 170px;
		position: absolute;
		top: 180px;
		right: 0px;
		text-align: left;
	}

	// .car-box.group-box div{ position: absolute; bottom: 94px; left: 44px;line-height: 17px;}
	.car-box.group-box div li {
		font-size: 12px;
		min-height: 19px;
		margin-bottom: 6px;
	}

	.car-box ul li.smallBottom {
		margin-bottom: 5px !important;
		font-size: 12px
	}

	.portrait {
		position: absolute;
		width: 1.49333rem;
		height: 2.10667rem;
		display: block;
		left: 160px;
		top: 135px;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.isSSOC ul li {
		min-height: 17px;
		margin-bottom: 1.5px;
		font-size: 10px;
	}

	.group-box ul li {
		min-height: 18px;
		margin-bottom: 13px;
		font-size: 10px
	}

	.btn {
		display: block;
		width: 110px;
		height: 38px;
		margin: 38px auto 0;
		font-size: 14px;
		line-height: 38px;
		text-align: center;
		color: #fff;
		border-radius: 3px;
		background: #1989fa;
		cursor: pointer;
	}

	.btn:active {
		background: #1a6fa3;
	}

	.group-box .qrCode {
		bottom: 37px;
	}

	.qrCode {
		position: absolute;
		bottom: 25px;
		width: 46px;
		height: 46px;
		display: flex;
		overflow: hidden;
		align-items: center;
		justify-content: center;
		right: 130px;
	}
</style>